import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedOvw202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_ovw_202605",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 62918,
  clicks: 1262,
  adsSpendDollars: 4884,
  budgetDollars: 5000,
  salesDollars: 28904,
  bestEstimateRoas: 5.92,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.98,
  newCustomersAcquired: 69,
  reorderConversions: 27,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
